<template>
  <div id="trace-env">
    <div class="env-item bg-light">
      <div class="env-item-label">
        指标名称
        <div class="line"></div>
      </div>
      <ul class="env-item-list">
        <li class="env-item-value" v-for="(item, index) in getEnvironMessage" :key="index">
          {{ item.name + '-' + item.number }}
        </li>
      </ul>
    </div>
    <div class="env-item bg-dark">
      <div class="env-item-label">
        最小值
        <div class="line"></div>
      </div>
      <ul class="env-item-list">
        <li class="env-item-value" v-for="(item, index) in getEnvironMessage" :key="index">
          {{ item.min_number }}
        </li>
      </ul>
    </div>
    <div class="env-item bg-light">
      <div class="env-item-label">
        平均值
        <div class="line"></div>
      </div>
      <ul class="env-item-list">
        <li class="env-item-value" v-for="(item, index) in getEnvironMessage" :key="index">
          {{ item.mean_number }}
        </li>
      </ul>
    </div>
    <div class="env-item bg-dark">
      <div class="env-item-label">
        最大值
        <div class="line"></div>
      </div>
      <ul class="env-item-list">
        <li class="env-item-value" v-for="(item, index) in getEnvironMessage" :key="index">
          {{ item.max_number }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "trace-env",
  data() {
    return {
      targetTimer: null,
    };
  },
  mounted() {
    // this.targetTimer = setTimeout(() => {
    //   this.$store.commit("trace/setEnvMessageGroup");
    // }, 2000);
  },
  computed: {
    ...mapGetters("trace", ["getEnvironMessage"]),
  }
};
</script>

<style scoped>
#trace-env {
  width: 100%;
  height: 100%;
  display: flex;
}

.env-item {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 25%;
  height: 100%;
  overflow: hidden;
}

.bg-light {
  background-color: rgba(0, 57, 101, 0.8);
}

.bg-dark {
  background-color: rgba(1, 23, 41, 0.8);
}

.env-item-label {
  position: relative;
  width: 100%;
  height: 1.2vw;
  line-height: 1.2vw;
  text-align: center;
  font-size: 0.5vw;
  color: #a7a7a7;
  align-self: flex-start;
}

.line {
  width: 80%;
  margin: 0 auto;
  height: 0.05vw;
  background-color: #a7a7a7;
  align-self: flex-start;
}

.env-item-list {
  list-style: none;
  width: 100%;
  height: calc(100% - 1.25vw);
  padding: 0.1vw 0;
}

.env-item-value {
  text-align: center;
  font-size: 0.5vw;
  width: 100%;
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
